import type { CharterCabinClass } from '~/components/Flights/Charter/charter.types';

export const charterAirportOptions = ['MEL', 'MLE'] as const;

export const charterCabinOptions: Array<{ value: CharterCabinClass; label: string }> = [
  { value: 'economy', label: 'Economy' },
  { value: 'lux_row', label: 'Economy Extra' },
  { value: 'premium_economy', label: 'Premium Economy' },
  { value: 'business', label: 'Business' },
];

const charterCabinLabelByValue = new Map<CharterCabinClass, string>(
  charterCabinOptions.map((option) => [option.value, option.label]),
);

export function getCharterCabinLabel(cabin: CharterCabinClass): string {
  return charterCabinLabelByValue.get(cabin) ?? cabin;
}
